module.exports = __webpack_public_path__ + "images/5c87a7f0dc9965d168432ad171f59496-cs5.jpg";